import { useEffect,  useState } from "react";
import BackIcon from "../../../assets/images/BackIcon";
import {
  OnboardConstants,
  StaffListConstants,
  pageRouteConstants,
} from "../../../constants/constants";
import React from "react";
import DoneIcon from "../../../assets/images/DoneIcon";
import { useNavigate } from "react-router-dom";
import { SideMenuPersonalInformation } from "../../common/SideMenuPersonalInformation";

import {
  resetFaceRecignitionStatus,
  resetPhoneNumberStatus,
  resetResendConsentSMSStatus,
  resetUserVerificationStatus,
} from "../../../store/slices/userDetailslice";
import ProfileImage from "../../../assets/images/logoOnboard.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { SideMenuStaffVerification } from "../../common/SideMenuStaffVerification";
import { readFromLocalStorage } from "../../../utils/DataEncryption";
import PopupModalWithCancelButton from "../../common/PopupModalWithCancelButton";
import OnboardSideMenu from "../../common/OnboardSideMenu";
import { fetchUserOnboardingFeildsAsync } from "../../../store/thunks/userOnboardThunk";

const Onboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchUserOnboardingFeildsAsync());
  }, []);

  const [segmentOrder, setSegmentOrder] = useState<number>(0);
  const userOnboardingJson = useSelector(
    (state: RootState) => state?.userOnboardingJsonDetails?.userOnboardingJson
  );
  const isEkycRequired = useSelector(
    (state: RootState) => state?.userOnboardingJsonDetails?.isEkycRequired
  );
  const userOnboardingJsonStatus = useSelector(
    (state: RootState) =>
      state?.userOnboardingJsonDetails?.userOnboardingJsonStatus
  );


  const [sideMenu, setSideMenu] = useState<string[]>([]);
  console.log(userOnboardingJson, "userOnboardingJson");
  useEffect(() => {
    if (userOnboardingJson && userOnboardingJson.length > 0) {
      let menuItems = userOnboardingJson.map(
        (item: { name: any }) => item?.name
      );

      if (isEkycRequired) {
        menuItems.push("Staff Verification");
      }

      setSideMenu(menuItems);
    }
  }, [userOnboardingJson, userOnboardingJsonStatus, isEkycRequired]);

  const onClickToNextPage = () => {
    setSegmentOrder(segmentOrder + 1);
    setSelectedMenu(selectedMenu + 1);
  };
  const onClickToPreviousPage = () => {
    setSegmentOrder(segmentOrder - 1);
    setSelectedMenu(selectedMenu - 1);
  };

  const unselectedStyle =
    "text-borderColor border border-primary bg-whiteColor text-primary h-6 w-6 rounded-full  flex items-center justify-center text4";
  const selectedStyle =
    " bg-primary text-white border border-black h-6 w-6 rounded-full  flex items-center justify-center text4";
  const [selectedMenu, setSelectedMenu] = useState(0);

  const [capturedImage, setCapturedImage] = useState<string | undefined>();

  const [showPopUp, setShowPopUp] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const userDetails = useSelector(
    (state: RootState) => state?.userDetails?.user
  );
  const [userInformation, setUserInformation] = useState(userDetails);
  const [ekycStatus, setEkycStatus] = useState(true);
  useEffect(() => {
    let userId = readFromLocalStorage("userIdForStaffVerification");
    if (userId && userId.toString() !== "") {
      setSelectedMenu(4);
    }
  }, []);

  useEffect(() => {
    if (
      userInformation?.ekycStatus?.bank === true &&
      userInformation?.ekycStatus?.drivingLicense === true &&
      userInformation?.ekycStatus?.pan === true
    ) {
      setEkycStatus(false);
    }
  }, [userInformation, sideMenu]);
  const componentMap: Record<number, React.ComponentType<any>> = {
    0: SideMenuPersonalInformation,
    1: SideMenuPersonalInformation,
    2: SideMenuPersonalInformation,
    3: SideMenuPersonalInformation,
    4: SideMenuStaffVerification,
  };
  const SelectedComponent = componentMap[selectedMenu];

  const goBackToDashBoardPage = () => {
    sessionStorage.removeItem("userIdForStaffVerification");

    dispatch(resetFaceRecignitionStatus());
    setCapturedImage("");
    dispatch(resetPhoneNumberStatus());
    navigate(pageRouteConstants.dashBoardRoute);
  };
  const handelCancelButton = () => {
    setShowPopUp(false);
  };
  return (
    <div className="md:p-12 bg-[#F4F4F4] md:bg-white">
      <div className="items-center hidden md:block">
        <img alt="ProfileImg" src={ProfileImage} />
      </div>
      <div className="flex  md:mt-14 justify-between bg-white pb-5 md:pb-0">
        <div className=" flex flex-col md:flex-row">
          <div
          data-testid="back-button"
            onClick={() => {
              setShowPopUp(true);
            }}
            className="mt-2 md:mt-0 bg-primary w-[40px] h-[40px] flex items-center justify-center cursor-pointer mr-3 ml-2 md:ml-0 rounded-lg"
          >
            <BackIcon />
          </div>
          <div>
            <div>
              <div className="consentHeaderText text-black  md:dashBoardTileCount ml-[4vw] md:ml-[0vw] font-poppins">
                {OnboardConstants.UserProfileSettup}
              </div>
              <div className="text3 text-black mt-2 hidden md:block">
                {OnboardConstants.Fillin}
              </div>
            </div>
          </div>
        </div>
        {selectedMenu === 4 && ekycStatus && (
          <div
            className="mt-8 mr-8 downloadSampleConsentText font-nunito underline cursor-pointer"
            onClick={() => {
              sessionStorage.removeItem("userIdForStaffVerification");
              dispatch(resetUserVerificationStatus());
              dispatch(resetResendConsentSMSStatus());
              navigate(pageRouteConstants.dashBoardRoute);
            }}
          >
            skip
          </div>
        )}
      </div>
      {/* *********************? side menu bar */}
      <div className="md:flex md:mt-[6vh]">
        <div className="h-[91vh] w-[18vw] bg-sideMenuInRegisterUserBackground hidden md:block rounded-lg  ">
          <div className=" text5 p-6 border-b-2 border-border font-poppins">
            {OnboardConstants?.steps}
          </div>
          {sideMenu.length > 0 ? (
            sideMenu.map((ele: string, index: number) => (
              <div key={index} className="flex cursor-pointer mt-8 ml-4">
                {selectedMenu > index ? (
                  <DoneIcon />
                ) : (
                  <div
                    className={
                      selectedMenu === index ? selectedStyle : unselectedStyle
                    }
                  >
                    {index + 1}
                  </div>
                )}
                <div className="ml-6 w-[200px] subtitle text-black">{ele}</div>
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
        <div className="block md:hidden mb-6 bg-white shadow-custom-light">
          <OnboardSideMenu
            selectedMenu={selectedMenu}
            jsonobj={userOnboardingJson}
          />
        </div>
        <div className="grow bg-white pt-4 md:pt-0">
          {SelectedComponent && userOnboardingJson && (
            <SelectedComponent
              setCapturedImage={setCapturedImage}
              capturedImage={capturedImage}
              setSelectedMenu={setSelectedMenu}
              selectedMenu={selectedMenu}
              jsonObjForRenderingUi={userOnboardingJson}
              order={segmentOrder}
              setSegementOrder={setSegmentOrder}
              onClickToNextPage={onClickToNextPage}
              onClickToPreviousPage={onClickToPreviousPage}
            />
          )}
        </div>
      </div>
      {showPopUp && (
        <PopupModalWithCancelButton
          popUpTitle={StaffListConstants.AreYouSure}
          popUpMsg={
            "You have unsaved changes. If you go back now, your changes will be lost. Do you want to continue?"
          }
          isOpen={true}
          onOkay={goBackToDashBoardPage}
          onCancel={handelCancelButton}
        />
      )}
    </div>
  );
};
export default Onboard;
